import React, { memo } from 'react'
import { useSelector } from 'react-redux'

import { usernameSelector, shouldSeeWelcomeSelector } from 'selectors/users'
import { useRoutes, useNavigateOnClick } from 'effects/useRoutes'


// Use memo to cut out extraneous renders of this very static component
const HeaderNavigation = memo(() => {
  const
    loggedIn = useSelector(usernameSelector),
    shouldSeeWelcome = useSelector(shouldSeeWelcomeSelector)

  // hide nav links when not logged in
  if (!loggedIn) { return }

  // hide navigation links when user should see welcome page
  if (shouldSeeWelcome) { return }

  return (
    <ul className="main-nav-links">
      <li><HeaderNavLink text="Devices" /></li>
      <li><HeaderNavLink text="Feeds" /></li>
      <li><HeaderNavLink text="Dashboards" /></li>
      <li><HeaderNavLink text="Actions" /></li>
      <li><HeaderNavLink text="Power-Ups" route="services" /></li>
    </ul>
  )
})

export default HeaderNavigation

const HeaderNavLink = ({ title, text, route }) => {
  // require text
  if(!text) { throw new Error("text prop required for HeaderNavButton") }

  // default the title and route
  title = title || text
  route = route || text.toLowerCase()

  const href = useRoutes(route)
  const visitRoute = useNavigateOnClick(route)

  return (
    <a href={ href } onClick={ visitRoute } title={ title }>
      { text }
    </a>
  )
}
